let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3vVFy")).then(() => parcelRequire('jLPZF'));